export function isResultCommentPublicPath(pathname) {
    return /^\/result-comment\/[^/]+\/[^/]+$/.test(pathname || '');
}

export function isPublicPath(pathname) {
    if (
        Object.values(routes.public).some(
            (v) => typeof v === 'string' && v === pathname,
        )
    ) {
        return true;
    }
    return isResultCommentPublicPath(pathname);
}

const routes = {
    public: {
        login: '/login',
        forgotPassword: '/forgot-password',
        enterCode: '/enter-code',
        createPassword: '/create-password',
        registration: '/registration',
        registrationCorporate: '/registration-corporate',
        signUp: '/sign-up',
        confirmRegistration: '/confirm-registration',
        checkData: '/check-data',
        installation: '/installation',
        ssoAuthorization: '/sso/authorization',
        accessDenied: '/access-denied',
        resultCommentRoute: '/result-comment/:resultId/:fieldId',
        resultComment: (resultId, fieldId) => `/result-comment/${resultId}/${fieldId}`,
    },
    private: {
        main: '/',
        sso_warning: '/sso-warning',

        // Dashboard routes
        dashboard: '/dashboard',
        dashboardRedirect: (agencyId) => `/dashboard/redirect-from-mail/${agencyId}`,
        advancedMetrics: '/advanced-metrics',

        // Custom Inspections routes
        customInspections: '/custom-inspections',
        corporateCustomInspections: '/corporate/custom-inspections',
        customInspectionsBuild: '/custom-inspections/build',
        corporateCustomInspectionsBuild: '/corporate/custom-inspections/build',
        customInspectionsEdit: (id) => `/custom-inspections/edit-inspection/${id}`,
        corporateCustomInspectionsEdit: (id) => `/corporate/custom-inspections/edit-inspection/${id}`,
        corporateCustomInspectionsDetails: (id) => `/corporate/custom-inspections/details/${id}`,
        customInspectionsDetails: (id) => `/custom-inspections/details/${id}`,
        customInspectionsForms: (id) => `/custom-inspections/forms/${id}`,

        // Forms routes
        forms: '/forms',
        corporateForms: '/corporate/forms',
        formsCreate: '/forms/create-form',
        formsEdit: (id) => `/forms/edit-form/${id}`,
        corporateFormsCreate: '/corporate/forms/create-form',
        corporateFormsEdit: (id) => `/corporate/forms/edit-form/${id}`,

        // Inspections routes
        inspections: '/inspections',
        inspectionDetail: (id) => `/inspections/${id}`,
        inspectionForm: '/inspection-form',
        inspectionFormEdit: (id) => `/inspection-form/edit/${id}`,
        inspectionForms: '/inspection-forms',

        // Facility routes
        facility: '/facility',
        facilityEdit: (id) => `/facility/edit/${id}`,

        // Actions routes
        actions: '/actions',

        // Log Sheets routes
        logSheets: '/log-sheets',

        // Observation routes
        observation: '/observation',

        // User Management routes
        management: '/management',

        // Tools routes
        tools: '/tools',
        toolsCreate: '/tools/create',
        toolsEdit: (id) => `/tools/edit/${id}`,

        // Report routes
        report: '/report',

        // Fuel Receipt routes
        receiptForm: '/receipt-form',

        // FBO routes
        fboAll: '/fbo/all',
        fboInvited: '/fbo/invited',
        fboTrial: '/fbo/trial',
        fboInactive: '/fbo/inactive',
        fboDetail: (id) => `/fbo/${id}`,

        // Corporate routes
        corporateActive: '/corporate/active',
        corporateInactive: '/corporate/inactive',
        corporateDetail: (id) => `/corporate/${id}`,
        corporateDashboard: '/corporate-dashboard',
        fboManagement: '/fbo-management',

        // Settings routes
        settings: '/settings',
        languageManagement: '/language-management',
        corporateSettings: '/corporate-settings',
        fboSettings: '/fbo-settings',

        // Profile routes
        profile: '/profile',

        // Equipment routes
        equipmentType: '/equipment-type',
        equipmentTypeEdit: (id) => `/equipment-type/edit/${id}`,
        equipmentTypeAssigned: '/equipment-type/assigned',
        equipment: '/equipment',
        equipmentEdit: (id) => `/equipment/edit/${id}`,
        createEquipment: '/create-equipment',

        customEquipmentType: '/custom-equipment-type',

        historyLogs: '/history-logs',
        reportsHealthyList: '/reports-healthy-list',
        reportsHealthy: (id) => `/reports-healthy/${id}`,

    },
};

export default routes;
